import React,{useState} from "react";
import FilterBlock from "../../components/SearchResult/FilterBlock/FilterBlock";
import SearchList from "../../components/SearchResult/SearchList/SearchList";
import Map from "../../images/map.jpg"
import "./SearchResult.scss"

const SearchResult =(props)=> {

  const [show, setShow] = useState(false);

  const showMap=()=>{
    setShow(!show)
  }

    return(
        <React.Fragment>
          <div className={show ? "map-open" : "map-open2"}>
              <div className="map-box">
                <img src={Map} alt="" />
              </div>
              <div className="right_block">
              <FilterBlock showMapFn={showMap} show={show}/>   
              <SearchList/> 
              </div>
            </div>  
        </React.Fragment>
    )
}

export default SearchResult;